import { GoogleLogin } from '@react-oauth/google';

import { shouldShowGoogleSso } from '../../utils/browserEnvironment';

const SafeGoogleLogin = (props) => {
  if (!shouldShowGoogleSso()) {
    return null;
  }

  return <GoogleLogin {...props} />;
};

export default SafeGoogleLogin;
